import MlExperimentsIndex from './components/ml_experiments_index.vue';

export default MlExperimentsIndex;
